import { fetchJSONWithTimeout } from '@noths/polaris-client-utils';

import type { ContentstackPartner } from './types/PartnerPage.types';

export const PARTNER_CONTENT_API_PATH = '/api/partner-content';

export const fetchPartnerContentClient = async (
  shortcode: string,
): Promise<ContentstackPartner | null> => {
  const response = await fetchJSONWithTimeout(
    `${PARTNER_CONTENT_API_PATH}/${encodeURIComponent(shortcode)}`,
  );

  if (!response.ok) {
    return null;
  }

  return response.json();
};
